<template>
    <v-card>
        <iframe frameborder="0"
            width="100%"
            height="54"
            :src="track.stream"
            allowfullscreen></iframe>
        <v-card-text>
            {{ track.title }}
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'jazz-track',
    props: {
        track: { type: Object, required: true }
    }
}
</script>
